export const Brand = 'brand';
export const Primary = 'primary';
export const Success = 'success';
export const Danger = 'danger';
export const Warning = 'warning';
export const Info = 'info';

const AllColors = [Brand, Primary, Success, Danger, Success, Warning, Info];

const includes = v => {
  return AllColors.includes(v);
};

export default {
  Brand,
  Primary,
  Success,
  Danger,
  Warning,
  Info,
  includes
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/avatar/defined-colors.js